<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-powerpoint"
      texto-titulo="Listado de pedidos"
      :to-create-action="{ name: 'NuevoPedido' }"
      to-create-text="Nuevo pedido"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          ref="datatable"
          :url="urlWithParams"
          :fields="fields"
          :rowClick="ver"
          :toPesos="toPesos"
          :toDate="toDate"
          :toDateTime="toDateTime"
        >
          <template v-slot:filters>
            <div class="col-md-6 col-12 form-group">
              <select
                id="filtro_usuario"
                class="form-control form-control-sm"
                v-model="userId"
              >
                <option :value="null">Todos los vendedores</option>
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.nombre }}
                </option>
              </select>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from "@/components/layouts/DataList";
import axios from "axios";
export default {
  name: "ListarPedidosPendientes",
  components: {
    TituloComponent,
    DataList,
    BlockUI,
  },
  data() {
    return {
      userId: null,
      users: [],
      fields: [
        {
          name: "cliente.nombre",
          label: "",
          type: "title",
          class: "",
          append: " - ",
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-danger",
          prepend: "$",
        },
        {
          name: "dia_facturacion",
          label: "Fecha entrega",
          type: "field",
          class: "text-alternate",
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: "",
        },
        {
          name: "estado",
          label: "Estado",
          type: "field",
          class: "text-capitalize text-danger",
        },
        {
          name: "user.nombre",
          label: "Vendedor",
          type: "field",
          class: "",
        },
        {
          name: "cliente.saldo",
          label: "Saldo cliente",
          type: "field",
          class: "text-info",
          prepend: "$",
        },
        {
          name: "entrega",
          label: "Entrega",
          type: "field",
          class: "text-success",
          prepend: "$",
          default: "0.00",
        },
      ],
      toPesos: ["total", "cliente.saldo", "entrega"],
      toDate: ["dia_facturacion"],
      toDateTime: ["created_at"],
      loading: false,
    };
  },
  computed: {
    urlWithParams() {
      if (this.userId) {
        return `/pedidos/pendientes?userId=${this.userId}`;
      }
      return "/pedidos/pendientes";
    },
  },
  watch: {
    userId() {
      this.$nextTick(() => {
        this.$refs.datatable.update();
      });
    },
  },
  mounted() {
    this.getUsuarios();
  },
  methods: {
    ver(pedido) {
      this.$router.push("/comprobantes/nuevo/" + pedido.id);
    },
    getUsuarios() {
      axios.get("/users").then((res) => {
        this.users = res.data.filter((user) => user.estado === "Habilitado");
      });
    },
  },
};
</script>
